import { CLINIC, waLink, callLink } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { Clock, PhoneCall, Siren } from "lucide-react";

export default function TimingsEmergency() {
  const { lang, t } = useLang();
  const tm = t.timings;

  return (
    <section data-testid="timings-section" className="relative overflow-hidden bg-brand-ink py-20 text-white md:py-28">
      <div className="grain-overlay" />
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <Reveal>
          <div className="mb-8 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand-warm">
            <Clock className="h-4 w-4" strokeWidth={1.75} /> {tm.eyebrow}
          </div>
          <h2 className="font-display text-4xl font-normal leading-tight tracking-tight md:text-5xl">
            {tm.heading}
          </h2>
          <div className="mt-8 divide-y divide-white/10">
            {tm.days.map((row) => (
              <div key={row.d} className="flex items-center justify-between py-3.5">
                <span className="text-sm font-medium text-white/70">{row.d}</span>
                <span className={`text-sm font-semibold ${row.h === tm.days[6].h ? "text-brand-warm" : "text-white"}`}>
                  {row.h}
                </span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="flex h-full flex-col justify-between rounded-3xl bg-brand-warm p-8 md:p-10">
            <div>
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/20">
                <Siren className="h-7 w-7 text-white" strokeWidth={1.75} />
              </div>
              <h3 className="mt-6 font-display text-3xl leading-tight md:text-4xl">{tm.emgTitle}</h3>
              <p className="mt-4 text-white/90 leading-relaxed">{tm.emgBody}</p>
              <p className="mt-6 font-display text-3xl md:text-4xl">{CLINIC.phone}</p>
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={callLink}
                data-testid="emergency-call-btn"
                className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-brand-warm transition-transform duration-300 hover:-translate-y-0.5"
              >
                <PhoneCall className="h-5 w-5" strokeWidth={1.75} /> {tm.callEmg}
              </a>
              <a
                href={waLink(tm.emgMsg, lang)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="emergency-whatsapp-btn"
                className="inline-flex items-center gap-2 rounded-full border border-white/50 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-white/10"
              >
                {tm.waNow}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
